<template>
  <div>
    <div class="d-flex gap-x-8 flex-wrap gap-y-4">
      <div>
        <p class="mb-0 font-weight-medium">Segurança</p>
        <div class="d-flex gap-2 flex-wrap">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" size="26" :color="min3DSAmountStatus?.color">
                {{ min3DSAmountStatus?.icon }}
              </v-icon>
            </template>
            {{ min3DSAmountStatus?.text }}
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" size="20" :color="antifraudStatus?.color">
                {{ antifraudStatus?.icon }}
              </v-icon>
            </template>
            {{ antifraudStatus?.text }}
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                size="20"
                :color="disallowPaymentMethodsStatus?.color"
              >
                {{ disallowPaymentMethodsStatus?.icon }}
              </v-icon>
            </template>
            {{ disallowPaymentMethodsStatus?.text }}
          </v-tooltip>
        </div>
      </div>
      <v-divider vertical />
      <div>
        <p class="mb-0 font-weight-medium">Politicas</p>
        <div class="d-flex gap-2 flex-wrap">
          <v-chip x-small :color="item.ageGroup === 0 ? 'success' : 'info'">
            <span v-if="item.ageGroup === 0">Livre</span>
            <span v-else>{{ item.ageGroup }} anos</span>
          </v-chip>
          <v-chip x-small :color="item.maxTickets == 0 ? 'warning' : 'info'">
            <span v-if="item.maxTickets == 0">Sem restrição de compra</span>
            <span v-else>{{ item.maxTickets }} Ingressos</span>
          </v-chip>
          <v-chip
            v-if="item.maxTicketsPos"
            x-small
            :color="item.maxTicketsPos == 0 ? 'warning' : 'info'"
          >
            <span>{{ item.maxTicketsPos }} Ingresso{{
              item.maxTicketsPos !== 1 ? "s" : ""
            }} no POS</span>
          </v-chip>
          <v-chip v-if="item.fbPixelId" x-small color="info">
            <span>FB Pixel Ativo</span>
          </v-chip>
          <v-chip v-if="item.webhook" x-small color="info">
            <span>Webhook Ativo</span>
          </v-chip>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <p class="mb-0 font-weight-medium">Personalização</p>
      <div class="d-flex gap-2 flex-wrap">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              :color="item._count.Faq ? 'info' : 'grey lighten-1'"
            >
              mdi-frequently-asked-questions
            </v-icon>
          </template>
          {{ item._count.Faq || null }} FAQ{{
            item._count.Faq !== 1 ? "s" : ""
          }}
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              :color="item._count.Attraction ? 'info' : 'grey lighten-1'"
            >
              mdi-music
            </v-icon>
          </template>
          {{ item._count.Attraction || null }} Atração{{
            item._count.Attraction !== 1 ? "s" : ""
          }}
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              :color="item._count.Period ? 'info' : 'grey lighten-1'"
            >
              mdi-calendar-blank-multiple
            </v-icon>
          </template>
          {{ item._count.Period || null }} Período{{
            item._count.Period !== 1 ? "s" : ""
          }}
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              :color="!!item.imageMap ? 'info' : 'grey lighten-1'"
            >
              mdi-map
            </v-icon>
          </template>
          Mapa
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              :color="item._count.Table ? 'info' : 'grey lighten-1'"
            >
              mdi-table-chair
            </v-icon>
          </template>
          Mapa de Assentos
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              :color="item._count.Gallery ? 'info' : 'grey lighten-1'"
            >
              mdi-image-multiple
            </v-icon>
          </template>
          {{ item._count.Gallery || null }} Foto{{
            item._count.Gallery !== 1 ? "s" : ""
          }}
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              :color="item._count.Coupon ? 'info' : 'grey lighten-1'"
            >
              mdi-ticket-percent
            </v-icon>
          </template>
          {{ item._count.Coupon || null }} Campanha{{
            item._count.Coupon !== 1 ? "s" : ""
          }}
          de Cupo{{ item._count.Coupon !== 1 ? "ns" : "m" }}
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              :color="!!item.webhook ? 'info' : 'grey lighten-1'"
            >
              mdi-webhook
            </v-icon>
          </template>
          Webhook
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              :color="item.youtubeId ? 'info' : 'grey lighten-1'"
            >
              mdi-youtube
            </v-icon>
          </template>
          Vídeo
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="20"
              :color="item.spotifyId ? 'info' : 'grey lighten-1'"
            >
              mdi-spotify
            </v-icon>
          </template>
          Música
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    disallowPaymentMethodsStatus() {
      const party = this.item;
      if (!party) return { text: "Sem restrições", color: "warning" };
      if (
        !party.disallowOnlinePaymentMethods ||
        !party.disallowOnlinePaymentMethods.length
      )
        return {
          text: "Sem restrições",
          color: "warning",
          icon: "mdi-credit-card-settings",
        };
      else
        return {
          text: `${party.disallowOnlinePaymentMethods.join(
            ", "
          )} não permitido${
            party.disallowOnlinePaymentMethods.length > 1 ? "s" : ""
          }`,
          color: "success",
          icon: "mdi-credit-card-off",
        };
    },
    antifraudStatus() {
      const party = this.item;
      if (!party)
        return {
          text: "Anti-fraude desativado",
          color: "error",
          icon: "mdi-shield-off",
        };
      if (!party.startAnalysisDate)
        return {
          text: "Anti-fraude desativado",
          color: "error",
          icon: "mdi-shield-off",
        };

      const duration = moment.duration(
        moment(party.startAnalysisDate).diff(moment())
      );
      // is past
      if (duration.asMilliseconds() < 0)
        return {
          text: `Anti-fraude ativo ${duration.humanize(true)}`,
          color: "success",
          icon: "mdi-shield-check",
        };
      else
        return {
          text: `Anti-fraude pendente até ${moment(
            party.startAnalysisDate
          ).format("DD/MM/YYYY HH:mm")}`,
          color: "warning",
          icon: "mdi-shield-alert",
        };
    },
    min3DSAmountStatus() {
      const party = this.item;
      if (!party) return { text: "3DS desativado", color: "error" };
      if (party.min3DSAmount === -1)
        return {
          text: "3DS desativado",
          color: "error",
          icon: "mdi-video-3d-off",
        };
      if (party.min3DSAmount === 0)
        return {
          text: "3DS obrigatório",
          color: "success",
          icon: "mdi-video-3d",
        };
      return {
        text: `3DS a partir de ${party.min3DSAmount}`,
        color: "info",
        icon: "mdi-video-3d",
      };
    },
  },
};
</script>

<style></style>
